import { TLocale } from './locale';

export const privacyPolicyUrlMap: Record<TLocale, string> = {
  'en-GB': 'https://www.agroop.net/privacy-cookies',
  'fr-FR': 'https://www.agroop.net/fr/confidentialite-cookies',
  'es-ES': 'https://www.agroop.net/es/privacidad-cookies',
  'pt-PT': 'https://www.agroop.net/pt/privacidade-cookies',
  'pt-BR': 'https://www.agroop.net/pt/privacidade-cookies',
};

export const termsAndConditionsUrlMap: Record<TLocale, string> = {
  'en-GB': 'https://www.agroop.net/terms-conditions',
  'fr-FR': 'https://www.agroop.net/fr/termes-conditions',
  'es-ES': 'https://www.agroop.net/es/terminos-condiciones',
  'pt-PT': 'https://www.agroop.net/pt/termos-condicoes',
  'pt-BR': 'https://www.agroop.net/pt/termos-condicoes',
};

export const cookiesPolicyUrlMap: Record<TLocale, string> = {
  'en-GB': 'https://www.agroop.net/privacy-cookies',
  'fr-FR': 'https://www.agroop.net/fr/confidentialite-cookies',
  'es-ES': 'https://www.agroop.net/es/privacidad-cookies',
  'pt-PT': 'https://www.agroop.net/pt/privacidade-cookies',
  'pt-BR': 'https://www.agroop.net/pt/privacidade-cookies',
};

export const equipmentListUrlMap: Record<TLocale, string> = {
  'en-GB': 'https://www.agroop.net/devices',
  'fr-FR': 'https://www.agroop.net/fr/equipements',
  'es-ES': 'https://www.agroop.net/es/equipos',
  'pt-PT': 'https://www.agroop.net/pt/equipamentos',
  'pt-BR': 'https://www.agroop.net/pt/equipamentos',
};
